import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import { OptionKey } from '@common-fe/common-fe';
import _ from 'lodash';

import { api } from '@/api';
import { Pagination } from '@/common/types';
import { API_URL } from '@/dtos';

import { Statement, StatementPayload } from '../Statements.types';

interface Props {
  employeeId?: string;
  page: number;
  pageSize: number;
  searchString?: string;
  years?: OptionKey[];
  sortBy: OptionKey;
}

const useStatementsQuery = ({ page, pageSize, searchString, years, sortBy, employeeId }: Props) => {
  const { data, isLoading, isSuccess } = useQuery(
    [employeeId, searchString, page, pageSize, sortBy, years],
    () =>
      // TODO: DTO is missing
      api.get<Pagination<StatementPayload>>(API_URL.STATEMENTS, {
        params: _.pickBy({
          ...(searchString ? { name: searchString } : {}),
          sort: `generation_date,${sortBy}`,
          page: _.toString(page - 1),
          size: _.toString(pageSize),
          types: 'BANKING_STATEMENT, INVESTMENT_STATEMENT',
          employee_id: employeeId,
          statement_years: years && years.length ? years?.join(',') : undefined,
        }),
      }),
    {
      enabled: !!employeeId,
    }
  );
  const formattedData = useMemo(() => {
    const list = data?.data?.content || [];
    const formattedList: Statement[] = list.map(
      (statement: StatementPayload): Statement => ({
        id: `${statement.id || ''}`,
        name: statement.name,
        url: statement.file_url,
        documentId: statement.document_id,
      })
    );
    return formattedList;
  }, [data]);
  const total = useMemo(() => data?.data?.totalElements || 0, [data]);
  return {
    data: formattedData,
    total,
    isLoading,
    isSuccess,
  };
};

export default useStatementsQuery;
